import Instance from '../../../utils/Axios';

const AdicionarTipoFalta = (ydata, show) => async (dispatch) => {
  await Instance()
    .post('/tipofaltas/', { ydata })
    .then(({ data }) => {
      dispatch({ type: 'POST_TIPOFALTA', payload: data });
      show('success', 'Tipo de falta adicionada com sucesso!');
    })
    .catch((err) => {
      // eslint-disable-next-line eqeqeq
      if (err.response.status != 200) {
        // show('warning', 'Preencha todos os campos');
      }
    });
};

export default AdicionarTipoFalta;
